import { memo } from "react";

/**
 * PathFinder Avatar - The AI Journal Coach Identity Icon
 * A flame-within-circle design representing guidance and transformation
 */
const PathFinderAvatar = memo(({ size = 48, className = "" }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 48 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      aria-label="PathFinder Avatar"
    >
      {/* Circle background with gold border */}
      <circle
        cx="24"
        cy="24"
        r="22"
        fill="#0f1e1a"
        stroke="#BF9B5A"
        strokeWidth="1.5"
      />
      
      {/* Subtle orbital ring */}
      <circle
        cx="24"
        cy="24"
        r="18"
        fill="none"
        stroke="#BF9B5A"
        strokeWidth="0.5"
        opacity="0.3"
      />
      
      {/* Gold crosshair lines */}
      <line x1="24" y1="6" x2="24" y2="14" stroke="#BF9B5A" strokeWidth="0.5" opacity="0.3" />
      <line x1="24" y1="34" x2="24" y2="42" stroke="#BF9B5A" strokeWidth="0.5" opacity="0.3" />
      <line x1="6" y1="24" x2="14" y2="24" stroke="#BF9B5A" strokeWidth="0.5" opacity="0.3" />
      <line x1="34" y1="24" x2="42" y2="24" stroke="#BF9B5A" strokeWidth="0.5" opacity="0.3" />
      
      {/* Layered flame - bottom to top */}
      {/* Base layer - darkest */}
      <path
        d="M24 38C24 38 16 32 16 24C16 18 20 14 24 10C28 14 32 18 32 24C32 32 24 38 24 38Z"
        fill="#8a4a10"
      />
      
      {/* Second layer */}
      <path
        d="M24 36C24 36 18 31 18 25C18 20 21 16 24 13C27 16 30 20 30 25C30 31 24 36 24 36Z"
        fill="#c47020"
      />
      
      {/* Third layer */}
      <path
        d="M24 34C24 34 20 30 20 26C20 22 22 18 24 15C26 18 28 22 28 26C28 30 24 34 24 34Z"
        fill="#e09030"
      />
      
      {/* Fourth layer */}
      <path
        d="M24 32C24 32 21 29 21 26C21 23 22.5 20 24 17C25.5 20 27 23 27 26C27 29 24 32 24 32Z"
        fill="#f0b840"
      />
      
      {/* Inner glow - brightest */}
      <path
        d="M24 30C24 30 22 28 22 26C22 24 23 22 24 20C25 22 26 24 26 26C26 28 24 30 24 30Z"
        fill="#ffd870"
      />
      
      {/* Subtle inner highlight */}
      <ellipse
        cx="24"
        cy="24"
        rx="1.5"
        ry="2"
        fill="#fff8e0"
        opacity="0.6"
      />
    </svg>
  );
});

PathFinderAvatar.displayName = "PathFinderAvatar";

export default PathFinderAvatar;
